import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import {
  IStationRouteProps,
  removeStationFromStationRouteDtoMetadata,
  useTimezone,
  warnAndToastSimpleResult,
} from "@ryde/shared";

import { useStationRouteDtoActions } from "../../hooks";

export type IUseStationRouteStationCtxProvider = ReturnType<
  typeof useStationRouteStationCtxProvider
>;

export const useStationRouteStationCtxProvider = (
  props: IStationRouteProps,
) => {
  const { t } = useTranslation();
  const { station, stationRouteDto } = props;
  const { timezone } = useTimezone();
  const {
    updateEditingStationRouteComputedData,
    stationRouteRebuildRouteHandler,
  } = useStationRouteDtoActions();

  const removeStationRouteStation = useEvent(async (): Promise<void> => {
    const computedDataUpdated = removeStationFromStationRouteDtoMetadata(
      stationRouteDto,
      [station.id],
      timezone,
      false,
    );

    const result = await updateEditingStationRouteComputedData({
      computedData: computedDataUpdated,
      direction: stationRouteDto?.metadata?.direction,
      optimize: false,
    });

    if (result.success) {
      return;
    }

    await updateEditingStationRouteComputedData({
      computedData: computedDataUpdated,
      direction: stationRouteDto?.metadata?.direction,
      optimize: false,
      skipApiCheck: true,
    });

    const rebuildResult = await stationRouteRebuildRouteHandler(false);
    if (!rebuildResult.success) {
      warnAndToastSimpleResult(rebuildResult, t);
    }
  });

  return {
    removeStationRouteStation,
  };
};
